import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { FieldEnum } from 'src/app/features/video/model/search-query';
import { SortByModel } from 'src/app/features/handball/video-quering/model/sort-by-model';
import { SelectorModel } from 'src/app/fragments/selector/selector-model';
import { SelectorComponent } from 'src/app/fragments/selector/selector.component';

@Component({
  selector: 'app-video-sort-by',
  templateUrl: 'video-sort-by.component.html',
  styleUrls: ['video-sort-by.component.scss'],
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatIcon,
    SelectorComponent
  ],
})
export class VideoSortByComponent implements OnInit {

  @Output() onSortByApplied: EventEmitter<any> = new EventEmitter();

  sortCriteria: SortByModel = {
    field: '',
    order: 'ASC',
  };

  selectedField: SelectorModel | null | undefined = null;
  fieldOptions: SelectorModel[] = [
    {
      id: '-',
      label: 'Título',
      value: "title",
    },
    {
      id: 'description',
      label: 'Descripción',
      value: "description",
    },
    {
      id: 'date',
      label: 'Fecha',
      value: "date",
    },
    {
      id: 'duration_in_seconds',
      label: 'Duración',
      value: "duration_in_seconds",
    }
  ];

  selectedCriteria: SelectorModel | null | undefined = null;
  criteriaOptions: SelectorModel[] = [
    {
      id: 'ASC',
      label: 'Ascendente (de menor a mayor)',
      value: "ASC",
    },
    {
      id: 'DESC',
      label: 'Descendente (de mayor a menor)',
      value: "DESC",
    }
  ];

  constructor() { }

  ngOnInit() {
  }

  applySortCriteria() {

    if (!this.isSortByApplied()) {
      this.onSortByApplied.emit(null);
      return;
    }


    const videoSortCriteria = {
      ...this.sortCriteria,
    };

    this.onSortByApplied.emit(videoSortCriteria);
  }

  resetSortingCriteria() {
    this.sortCriteria = {
      field: '',
      order: 'ASC',
    };
    this.applySortCriteria();
  }

  isSortByApplied() {
    return this.sortCriteria.field !== '' && this.sortCriteria.order !== '';
  }

  protected getOption(value: string, options: SelectorModel[]): SelectorModel | undefined {
    return options.find(option => option.value === value);
  }

  protected validateSortCriteria(value: string): "ASC" | "DESC" | "" {
    if (value === "ASC" || value === "DESC") {
      return value;
    }
    return "";
  }

}
